import React from 'react';
import { FiCheck } from "react-icons/fi";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ContentPricing = () => {
    return (
        <div className="row row--15">

            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-2">
                    <div className="pricing-table-inner">
                        <div className="pricing-header">
                            <h4 className="title">Monthly</h4>
                            <div className="pricing">
                                <div>
                                    <h4>
                                        <del className="text-danger">৳1200</del>
                                    </h4>
                                </div>
                                <div className="price-wrapper">
                                    <span className="currency">৳</span>
                                    <span className="price">490</span>
                                </div>
                                <span className="subtitle">For Month</span>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-style--1">
                                <li><FiCheck /> Unlimited Access</li>
                                <li><FiCheck /> All Content</li>
                                <li><FiCheck /> Psychological Health</li>
                                <li><FiCheck /> Physical Health</li>
                                <li><FiCheck /> Emotional Health</li>
                                <li><FiCheck /> Financial Health</li>
                                <li><FiCheck /> Spiritual Health</li>
                            </ul>
                        </div>
                        <div className="pricing-footer">
                            <Link className="btn-default" to={`/order?service=Content&package=Monthly&amount=1200`}>Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}

            {/* Start PRicing Table Area  */}
            {/* <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-2">
                    <div className="pricing-table-inner">
                        <div className="pricing-header">
                            <h4 className="title">Quarterly</h4>
                            <div className="pricing">
                                <div>
                                    <h4>
                                        <del className="text-danger">৳6000</del>
                                    </h4>
                                </div>
                                <div className="price-wrapper">
                                    <span className="currency">৳</span>
                                    <span className="price">2500</span>
                                </div>
                                <span className="subtitle">For 3 Month</span>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-style--1">
                                <li><FiCheck /> Unlimited Access</li>
                                <li><FiCheck /> All Content</li>
                                <li><FiCheck /> Psychological Health</li>
                                <li><FiCheck /> Physical Health</li>
                                <li><FiCheck /> Emotional Health</li>
                                <li><FiCheck /> Financial Health</li>
                                <li><FiCheck /> Spiritual Health</li>
                            </ul>
                        </div>
                        <div className="pricing-footer">
                            <Link className="btn-default" to={`/order?service=Content&package=Quarterly&amount=2500`}>Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* End PRicing Table Area  */}
            {/* Start PRicing Table Area  */}
            {/* <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-2">
                    <div className="pricing-table-inner">
                        <div className="pricing-header">
                            <h4 className="title">Half Yearly</h4>
                            <div className="pricing">
                                <div>
                                    <h4>
                                        <del className="text-danger">৳12000</del>
                                    </h4>
                                </div>
                                <div className="price-wrapper">
                                    <span className="currency">৳</span>
                                    <span className="price">4000</span>
                                </div>
                                <span className="subtitle">For 6 Month</span>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-style--1">
                                <li><FiCheck /> Unlimited Access</li>
                                <li><FiCheck /> All Content</li>
                                <li><FiCheck /> Psychological Health</li>
                                <li><FiCheck /> Physical Health</li>
                                <li><FiCheck /> Emotional Health</li>
                                <li><FiCheck /> Financial Health</li>
                                <li><FiCheck /> Spiritual Health</li>
                            </ul>
                        </div>
                        <div className="pricing-footer">
                            <Link className="btn-default" to={`/order?service=Content&package=Half Yearly&amount=4000`}>Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* End PRicing Table Area  */}

            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-2">
                    <div className="pricing-table-inner">
                        <div className="pricing-header">
                            <h4 className="title">Yearly</h4>
                            <div className="pricing">
                                <div>
                                    <h4>
                                        <del className="text-danger">৳6000</del>
                                    </h4>
                                </div>
                                <div className="price-wrapper">
                                    <span className="currency">৳</span>
                                    <span className="price">990</span>
                                </div>
                                <span className="subtitle">For 1 Year</span>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-style--1">
                                <li><FiCheck /> Unlimited Access</li>
                                <li><FiCheck /> All Content</li>
                                <li><FiCheck /> Psychological Health</li>
                                <li><FiCheck /> Physical Health</li>
                                <li><FiCheck /> Emotional Health</li>
                                <li><FiCheck /> Financial Health</li>
                                <li><FiCheck /> Spiritual Health</li>
                            </ul>
                        </div>
                        <div className="pricing-footer">
                            <Link className="btn-default" to={`/order?service=Content&package=Yearly&amount=6000`}>Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}
            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-2">
                    <div className="pricing-table-inner">
                        <div className="pricing-header">
                            <h4 className="title">Lifetime</h4>
                            <div className="pricing">
                                <div>
                                    <h4>
                                        <del className="text-danger">৳12,000</del>
                                    </h4>
                                </div>
                                <div className="price-wrapper">
                                    <span className="currency">৳</span>
                                    <span className="price">2,990</span>
                                </div>
                                <span className="subtitle">Lifetime</span>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-style--1">
                                <li><FiCheck /> Unlimited Access</li>
                                <li><FiCheck /> All Content</li>
                                <li><FiCheck /> Psychological Health</li>
                                <li><FiCheck /> Physical Health</li>
                                <li><FiCheck /> Emotional Health</li>
                                <li><FiCheck /> Financial Health</li>
                                <li><FiCheck /> Spiritual Health</li>
                            </ul>
                        </div>
                        <div className="pricing-footer">
                            <Link className="btn-default" to={`/order?service=Content&package=Lifetime&amount=12000`}>Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}
        </div>
    )
}
export default ContentPricing;